<div class="container-fluid maap-root-container">
  <app-header></app-header>
  <app-sidebar></app-sidebar>

  <div class="stock-area-config-content">
    <div class="stock-area-config-header">
      <h1 class="standalone-page-title">Stock Area Configurations</h1>
    </div>

    <app-stock-area-table></app-stock-area-table>
  </div>
</div>
